import React, { Component } from 'react';
import * as Styles from './Styles';
import { ConnectedProps, connect } from 'react-redux';
import { AppState } from '../../core/Store';
import * as AppManager from '../../reducers/ui/app';

type State = {};

class BannerPendingComponent extends Component<PropsFromRedux, State> {
	state = {};

	componentDidMount(): void {
		// add interval
		const intervalId = setInterval(async () => {
			await AppManager.checkPaymentStatus();
		}, 5000);

		this.props.setLastPaymentIntervalId(intervalId);
	}

	componentWillUnmount(): void {
		this.props.lastPaymentIntervalId &&
			clearInterval(this.props.lastPaymentIntervalId);

		this.props.setLastPaymentIntervalId(null);
	}

	render() {
		return (
			<Styles.Wrapper>
				<Styles.ContentContainer>
					<Styles.HeadingsContainer>
						<Styles.HeadingFont>
							<span>Już prawie...</span>
						</Styles.HeadingFont>
						<Styles.GenericFont style={{ marginTop: '16px' }}>
							twoja płatność jest w trakcie realizacji...
						</Styles.GenericFont>
						<Styles.StyledSvgSpinner />
					</Styles.HeadingsContainer>
				</Styles.ContentContainer>
			</Styles.Wrapper>
		);
	}
}

interface Own {}

const connector = connect(
	(state: AppState, own: Own) => ({
		lastPaymentIntervalId:
			AppManager.Selectors.getLastPaymentIntervalId(state),
	}),
	(dispatch) => ({
		setLastPaymentIntervalId: (id: NodeJS.Timer | null) =>
			dispatch(AppManager.Actions.setLastPaymentIntervalId(id)),
	})
);

export type PropsFromRedux = ConnectedProps<typeof connector> & Own;

const BannerPending = connector(BannerPendingComponent);
export default BannerPending;
